import {
  Container,
  Box,
  Grid,
  Card,
  CardContent,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Paper,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
// import useStyles from "./styles";

import { useSharedBookReducer } from "../state";

const SidebarHelp = (props) => {
  const [bookState, dispatch] = useSharedBookReducer();

  const handleChangeNote = (e) => {
    dispatch({
      type: "MERGE",
      payload: {
        m: { notes: e.target.value },
      },
    });
  };

  return (
    <>
      <Box>
        Have questions, or a custom order?
        <br />
        <br />
        <a href="tel:8312648008">
          <span>Call: (831) 264-8008</span>
        </a>
        <br />
        <a href="mailto:hello@bigsurfadventures.com">
          <span>Email: hello@bigsurfadventures.com</span>
        </a>
        <br />
      </Box>
    </>
  );
};

export default SidebarHelp;
